export enum Commerce {
  LANDSCAPE = 'landscape',
  MOBILE_LANDSCAPE = 'mobileLandscape',
  MOBILE_PORTRAIT = 'mobilePortrait',
  DESKTOP_LANDSCAPE = 'desktopLandscape'
}
